import PropTypes from 'prop-types';

export const ResourceOrderFormActions = ({
  handleOnUpload,
  handleOnView,
  enableViewButton,
  handleDeleteRof,
  handleOnEdit,
  className,
  disabled,
  viewOnly = false,
}) => {
  return (
    <>
      {!viewOnly && (
        <input
          type='button'
          id='upload_ROF'
          className={`${className} button save_manifest ${disabled ? 'btn-disabled' : ''}`}
          onClick={() => handleOnUpload()}
          value='Resource Order'
          name='upload_ROF'
          disabled={disabled}
        ></input>
      )}

      {enableViewButton && (
        <>
          {!viewOnly && (
            <input
              type='button'
              id='delete_ROF'
              onClick={() => handleDeleteRof()}
              value='Delete RO'
              name='delete_ROF'
              disabled={disabled}
              className={`button save_manifest ${disabled ? 'btn-disabled' : ''}`}
            ></input>
          )}

          <input
            type='button'
            id='view_ROF'
            onClick={() => handleOnView()}
            value='View RO'
            name='view_ROF'
            disabled={disabled}
            className={`button save_manifest ${disabled ? 'btn-disabled' : ''}`}
          ></input>
          {enableViewButton?.resource_order_form_type === 1 && !viewOnly && (
            <input
              type='button'
              id='edit_ROF'
              onClick={() => handleOnEdit()}
              value='Edit RO'
              name='edit_ROF'
              disabled={disabled}
              className={`button save_manifest ${
                disabled ? 'btn-disabled' : ''
              }`}
            ></input>
          )}
        </>
      )}
    </>
  );
};

ResourceOrderFormActions.propTypes = {
  handleOnUpload: PropTypes.func.isRequired,
  handleOnView: PropTypes.func.isRequired,
  handleDeleteRof: PropTypes.func.isRequired,
  handleOnEdit: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  viewOnly: PropTypes.bool,
  enableViewButton: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      resource_order_form_type: PropTypes.number,
    }),
  ]),
};